export default {
  global: {
    yes: '是',
    no: '否',
    cancel: '取消',
    confirm: '确定',
    saveAs: '另存为',
    close: '关闭',
    operation: '操作',
    unknownError: '未知错误',
    more: '更多',
    loading: '加载中',
    delete: '删除',
    success: '成功',
    error: '失败',
    rows: '条',
    edit: '编辑',
    save: '保存',
    complete: '完成',
    deleteSuccessful:'删除成功',
  },
  LnkAddressCascader:{
    placeholder:'请选择地区...'
  },
  LnkAuditTrail:{
    title:'修改历史',
    fieldAttr1:'用户名',
    fieldAttr2:'修改人',
    fieldOperate:'操作',
    fieldCreated:'修改时间',
    fieldOldValue:'原值',
    fieldNewValue:'新值'
  },
  LnkBigfileUploader:{
    successText:'已上传',
    errorText:'出错了',
    uploadingText:'上传中',
    pausedText:'暂停中',
    waitingText:'等待中',
    totalText:'共',
    remainlingText:'还剩',
    progressText:'进度'
  },
  LnkCombinefilter:{
    title:'组合查询',
    labelFilter:'筛选条件',
    labelLogic:'逻辑条件',
    placeholderField:'请选择字段…',
    placeholderCondition:'请选择筛选方式…',
    placeholderSelect:'请选择筛选值…',
    placeholderDate:'请选择日期…',
    placeholderDaterange:'请选择日期范围…',
    placeholderInput:'请输入筛选值…',
    btnClear:'清空',
    btnAddSingleFilter:'单字段筛选',
    btnAddMultiFilter:'多字段筛选',
    btnAdjustLogic:'自定义',
    btnChooseQuery:'选择查询',
    titleSaveDialog:'保存',
    fieldFilterDescribe:'描述',
    and: '且',
    or: '或'
  },
  LnkExportPick:{
    title:'导出选择',
    fieldIndex:'序列',
    fieldName:'显示名称',
    fieldField:'数据列名',
    placeholderFilename:'请输入文件名称...',
    placeholderFiletype:'文件类型...',
    btnTotop:'置顶',
    btnUpwards:'往上',
    btnDownwards:'往下',
    btnExportall:'导出全部',
    btnExportcrt:'导出当前页',
  },
  LnkFeedback:{
    title:'任务反馈',
    hintLoading:'加载中...',
    fieldProjName:'项目名称',
    fieldProjModel:'模块',
    fieldPFirstName:'提出人',
    fieldRFirstName:'责任人',
    fieldAbstracts:'内容',
    fieldSelectdate:'时间',
    placeholderAbstracts:'请输入内容...',
    placeholderBeginDate:'开始日期',
    placeholderEndDate:'结束日期',
    labelScreenCut:'上传截图',
    fieldPicture:'上传图片',
    fieldNone:'不上传图片',
    fieldPaste:'粘贴图片',
    hintUploadErr:'图片保存失败!',
    hintForm:'请完成必输信息的填写',
  },
  LnkLov:{
    placeholder:'请选择'
  },
  LnkMvg:{
    cancel:'取消'
  },
  LnkPaginationV:{
    labelRightHint:'当前显示 %{startRow}-%{endRow}，共 <a href="###" class="total-num">%{totalHint}</a> 条记录'
  },
  LnkSimpleTable:{
    hintLoading:'正在处理...',
    btnDelete:'删除',
    menuMore:'更多',
    menuImport:'导入',
    menuExport:'导出',
    menuHistory:'修改历史',
    menuMultiSearch:'组合查询',
    menuRecordDetail:'记录明细',
    menuRecordTotal:'记录计数'
  },
  LnkTableDatapanel:{
    hintLoading:'正在处理...',
    menuMore:'更多',
    menuImport:'导入',
    menuExport:'导出',
    menuMultiSearch:'组合查询',
    menuRecordDetail:'记录明细',
    menuRecordTotal:'记录计数',
    hintTitle:'提示',
    hintClearlist:'确定清除列表？',
    hintDelete:'确定删除这条记录？',
    hintNoDataSelected:'请选中一条记录',
    hintEmptyTable:'空列表',
    hintRecordTotal:'当前记录总数: %{n}',
    hintDeleteSuccess:'删除成功！',
    hintImportSuccess:'导入成功！'
  },
  LnkTableSelectfilter:{
    fieldPlaceholder: '请选择搜索字段',
    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    datePlaceholder: '请选择日期',
    dateRangePlaceholder: '请选择日期范围',
    beginDatePlaceholder:'开始日期',
    endDatePlaceholder:'结束日期',
    searchButton:'查询',
    notNull:'非空',
    isNull:'空值'
  },
  LnkValuelistCascader:{
    placeholder:'请选择...'
  },
  LnkWxImage:{
    title:'选择图片',
    searchPlaceholder:'请输入图片名称',
    noDescribe:'暂无描述'
  },
  LnkWxImageText:{
    title:'选择图文',
    searchPlaceholder:'请输入图文名称',
  },

  LinkForm: {
    reset: '重置',
    query: '查询',
    to: '至',
    now: '今',
    year: '年',
    month: '月',
    day: '日',
    week:['日','一','二','三','四','五','六'],
    rowsPage: '条/页',
    goto: '前往',
    page: '页',
    pickProvince:'请先选择省份',
    pickCity:'请先选择城市',
    pickAddress:'请选择地址',
    province:'省份',
    city:'城市',
    district:'区/县',
    selectPlaceholder:'请选择',
    selectSearchField:'选择搜索字段',
    clickToInputContent:'点击输入内容',
    tips:'提示',
    pleaseSelectParentLov:'请先选择父级值列表',
    notify:'通知',
  },
  LinkInput: {
    placeholder: '输入',
    requireText: '必填',
  },
  LinkService:{
    overMaxSize:'{name}大小为{nowSize}M，超过最大限制{maxSize}M',
    fileUploadFail:'文件上传失败',

  },
  LinkFilter:{
    largerThan:'大于',
    smallerThan:'小于',
    like:'模糊查询',
    equal:'等于',
    filterTimeFrame:'筛选时间范围',
    searchKey:'搜索关键字',
    filterKey:'筛选列表关键字',
    minValue:'最小值',
    maxValue:'最大值',
  },
  LinkValidateService: {
    lengthCannotBeLessThan: '长度不能小于{min}',
    lengthCannotBeLargeThan: '长度不能大于{max}',
    incorrectEmail: '邮箱格式不正确',
    incorrectPhoneNumber: '电话号码格式不正确',
    incorrectQQNum: 'qq号码格式不正确',
    incorrectIdCard: '身份证号格式不正确',
    pleaseEnterCorrectNumber: '请输入正确的数字',
    maxNumber: '最大值为{max}',
    minNumber: '最小值为{min}',
  },
  LinkAutoTable: {
    formQuery: '表单查询',
    clearFilter: '清空筛选',
    cancelQuery: '取消查询',
    currentPage: '当前显示',
  	total:'共',
  	records:'条记录',

    noData: '暂无数据',
    summary:'合计',
    selectAll:'全选',
    pleaseSelectAtLeastOneRow:'请至少选择一条数据',
    confirmDeleteRow:'确定要删除第 {val} 条数据吗？',
    currentRecordCounts:'当前记录总数：{val}',
    /*记录明细*/
    recordCode: '记录编号',
    createBy: '创建人',
    createAt: '创建时间',
    updateBy: '最后更新人',
    updateAt: '最后更新时间',
  	versionNumber: '版本号',
    /*筛选排序*/
    sort: '排序',
    sortAsc: '升序',
    sortDesc: '降序',
    noSort: '不排序',
    search: '搜索',
    filter: '筛选',
    /*导入导出*/
    import:'导入',
    exportOption: '导出选择',
    fileType: '文件类型',
    exportCurrentPage: '导出当前页',
    exportAll: '导出全部',
    downloadTemplate: '模板下载',
    nextStep: '下一步',
    prevStep: '上一步',
    clickToSelectFile: '点击选择文件',
    importTips: '只能上传excel、csv文件，且不超过15M',
    executeBackground: '提交到后台执行',
    sequence: '序号',
    handleStatus: '处理状态',
    errorMessage: '错误信息',
    operator: '操作',
    totalNumOfRecord: '总记录数 {val} 条',
    currentShowRows: '当前显示 {val}',
    showAll: '全部展示',
    currentStatus: '当前状态',
    handleTips: '正在处理 {val} 条',
    validateData: '校验数据',
    beginImport: '开始导入',
    showDataImported: '查看已导入数据',
    selectExportOption:'请选择导出项',
    selectExportFileType:'请选择导出文件类型',
    cannotFindImportTemplate:'未找到该页面的导入模板，请联系管理员',
    searchImportConfigFail:'查询导入配置失败',
    selectTemplate:'选择模板',
    pleaseSelectConfigYouNeed:'请选择需要的操作',
    uploadFile:'上传文件',
    pleaseUploadCorrectFile:'请上传excel，csv文件',
    validateImportData:'校验数据',
    pleaseCheckDataToBeImport:'请核对需要导入的数据',
    checkResult:'查看结果',
    pleaseCheckResultAndErrorData:'请查看结果和处理错误数据',
    queryDataFail:'查询数据失败',
    /*AutoTable标准按钮*/
    insertButton:'新建',
    copyButton:'复制',
    deleteButton:'删除',
    importButton:'导入',
    exportButton:'导出',
    batchInsertButton:'批量新建',
    batchUpdateButton:'批量编辑',
    combineSearchButton:'组合查询',
    combineSearchMangerButton:'查询管理',
    showCountButton:'记录计数',
    showRecordDetailButton:'记录明细',
    showModifyHistoryButton:'修改历史',
    showTableConfigButton:'自定义',
    showMoreRowsButton:'显示更多',
    batchModifyButton:'批量修改',
    forEditButton:'表单编辑',
    saveAndCreate:'保存并新建',
    continueCreate:'继续新建',
	clearCache:'清空缓存',
  },
};
